var _defs, _rect, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFotorgoart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 102.84759521484375,
    height: 30.847610473632812,
    viewBox: "0 0 102.84759521484375 30.847610473632812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    id: "master_svg0_1_319"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6100DF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8C00F3",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.8578860759735107,
    y1: 0.8597633242607117,
    x2: -0.2399289309978485,
    y2: -0.2765883505344391,
    id: "master_svg1_1_284"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#B200BB",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7F00D4",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 2.4512760639190674,
    y1: 1.268548846244812,
    x2: -2.2118921279907227,
    y2: -1.200913429260254,
    id: "master_svg2_1_279"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F61B4A",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF1365",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1,
    y1: -2.9802322387695312e-8,
    x2: 0.5,
    y2: 1.3333333730697632,
    id: "master_svg3_1_294"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1A31FD",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99.99992251396179%",
    stopColor: "#4677FD",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -0.035017237067222595,
    y1: 1.0188000202178955,
    x2: 1.1166709661483765,
    y2: -0.0556098073720932,
    id: "master_svg4_1_289"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1BA7FF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0953FF",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -0.16657708585262299,
    y1: -1.6673908233642578,
    x2: 1.6047992706298828,
    y2: 2.7635462284088135,
    id: "master_svg5_1_274"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F9F26E",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF350",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.010019190609455109,
    y1: 0.009814964607357979,
    x2: 1.1810115575790405,
    y2: 1.1812903881072998,
    id: "master_svg6_1_264"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F3F314",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D8DC05",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.9001821279525757,
    y1: 0.0966641902923584,
    x2: -0.27103185653686523,
    y2: 1.3089913129806519,
    id: "master_svg7_1_304"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFCD50",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "98.57142567634583%",
    stopColor: "#FFBE22",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 2.3266992568969727,
    y1: 1.8836963176727295,
    x2: -2.0847716331481934,
    y2: -0.4517362117767334,
    id: "master_svg8_1_299"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FAD522",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FAE11C",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1.0316925048828125,
    y1: 3.13677716255188,
    x2: -1.0827641487121582,
    y2: -1.117309808731079,
    id: "master_svg9_1_269"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF8637",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD6E1B",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -1.9736230373382568,
    y1: 1.1028505563735962,
    x2: 1.797330617904663,
    y2: -0.049001336097717285,
    id: "master_svga_1_309"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#01CB75",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#02AA6B",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -1.7581160068511963,
    y1: -0.4311377704143524,
    x2: 2.3482563495635986,
    y2: 1.7436894178390503,
    id: "master_svgb_1_314"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#97E723",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7ACD00",
    stopOpacity: 1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.20000000298023224
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 30.84760856628418,
    height: 30.84760856628418,
    rx: 8,
    fill: "#FFFFFF",
    fillOpacity: 1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.42892074584961,28.043328125000002C15.42892074584961,28.043328125000002,22.71681074584961,28.043328125000002,22.71681074584961,28.043328125000002C22.71681074584961,28.043328125000002,15.42892074584961,15.423828125,15.42892074584961,15.423828125C15.42892074584961,15.423828125,15.42892074584961,28.043328125000002,15.42892074584961,28.043328125000002C15.42892074584961,28.043328125000002,15.42892074584961,28.043328125000002,15.42892074584961,28.043328125000002Z",
    fillRule: "evenodd",
    fill: "url(#master_svg0_1_319)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.72207074584961,28.043328125000002C22.72207074584961,28.043328125000002,22.821970745849608,28.043328125000002,22.821970745849608,28.043328125000002C25.69282074584961,28.043328125000002,28.04332074584961,25.692928125,28.04332074584961,22.821998125C28.04332074584961,22.821998125,28.04332074584961,22.706328125,28.04332074584961,22.706328125C28.04332074584961,22.706328125,15.42892074584961,15.423828125,15.42892074584961,15.423828125C15.42892074584961,15.423828125,22.72207074584961,28.043328125000002,22.72207074584961,28.043328125000002C22.72207074584961,28.043328125000002,22.72207074584961,28.043328125000002,22.72207074584961,28.043328125000002Z",
    fillRule: "evenodd",
    fill: "url(#master_svg1_1_284)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.42892074584961,15.423828125C15.42892074584961,15.423828125,28.04332074584961,22.706328125,28.04332074584961,22.706328125C28.04332074584961,22.706328125,28.04332074584961,15.423828125,28.04332074584961,15.423828125C28.04332074584961,15.423828125,15.42892074584961,15.423828125,15.42892074584961,15.423828125C15.42892074584961,15.423828125,15.42892074584961,15.423828125,15.42892074584961,15.423828125Z",
    fillRule: "evenodd",
    fill: "url(#master_svg2_1_279)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.146775245666504,28.043328125000002C8.146775245666504,28.043328125000002,15.429305245666505,28.043328125000002,15.429305245666505,28.043328125000002C15.429305245666505,28.043328125000002,15.429305245666505,15.423828125,15.429305245666505,15.423828125C15.429305245666505,15.423828125,8.146775245666504,28.043328125000002,8.146775245666504,28.043328125000002C8.146775245666504,28.043328125000002,8.146775245666504,28.043328125000002,8.146775245666504,28.043328125000002Z",
    fillRule: "evenodd",
    fill: "url(#master_svg3_1_294)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.80419921875,22.711568125C2.80419921875,22.711568125,2.80419921875,22.821998125,2.80419921875,22.821998125C2.80419921875,25.692928125,5.15460921875,28.043328125000002,8.03083921875,28.043328125000002C8.03083921875,28.043328125000002,8.146509218750001,28.043328125000002,8.146509218750001,28.043328125000002C8.146509218750001,28.043328125000002,15.42909921875,15.423828125,15.42909921875,15.423828125C15.42909921875,15.423828125,2.80419921875,22.711568125,2.80419921875,22.711568125C2.80419921875,22.711568125,2.80419921875,22.711568125,2.80419921875,22.711568125Z",
    fillRule: "evenodd",
    fill: "url(#master_svg4_1_289)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.141110897064209,2.804443359375C8.141110897064209,2.804443359375,15.42890089706421,15.423943359375,15.42890089706421,15.423943359375C15.42890089706421,15.423943359375,15.42890089706421,2.804443359375,15.42890089706421,2.804443359375C15.42890089706421,2.804443359375,8.141110897064209,2.804443359375,8.141110897064209,2.804443359375C8.141110897064209,2.804443359375,8.141110897064209,2.804443359375,8.141110897064209,2.804443359375Z",
    fillRule: "evenodd",
    fill: "url(#master_svg5_1_274)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.03083921875,2.804443359375C5.15460921875,2.804443359375,2.80419921875,5.154883359375,2.80419921875,8.025763359375C2.80419921875,8.025763359375,2.80419921875,8.136163359375,2.80419921875,8.136163359375C2.80419921875,8.136163359375,15.42909921875,15.423943359375,15.42909921875,15.423943359375C15.42909921875,15.423943359375,8.14124921875,2.804443359375,8.14124921875,2.804443359375C8.14124921875,2.804443359375,8.03083921875,2.804443359375,8.03083921875,2.804443359375C8.03083921875,2.804443359375,8.03083921875,2.804443359375,8.03083921875,2.804443359375Z",
    fillRule: "evenodd",
    fill: "url(#master_svg6_1_264)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.72207074584961,2.804443359375C22.72207074584961,2.804443359375,15.42892074584961,15.423943359375,15.42892074584961,15.423943359375C15.42892074584961,15.423943359375,28.04332074584961,8.146683359375,28.04332074584961,8.146683359375C28.04332074584961,8.146683359375,28.04332074584961,8.031023359375,28.04332074584961,8.031023359375C28.04332074584961,5.154883359375,25.69282074584961,2.804443359375,22.821970745849608,2.804443359375C22.821970745849608,2.804443359375,22.72207074584961,2.804443359375,22.72207074584961,2.804443359375C22.72207074584961,2.804443359375,22.72207074584961,2.804443359375,22.72207074584961,2.804443359375Z",
    fillRule: "evenodd",
    fill: "url(#master_svg7_1_304)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.42892074584961,2.804443359375C15.42892074584961,2.804443359375,15.42892074584961,15.423943359375,15.42892074584961,15.423943359375C15.42892074584961,15.423943359375,22.71681074584961,2.804443359375,22.71681074584961,2.804443359375C22.71681074584961,2.804443359375,15.42892074584961,2.804443359375,15.42892074584961,2.804443359375C15.42892074584961,2.804443359375,15.42892074584961,2.804443359375,15.42892074584961,2.804443359375Z",
    fillRule: "evenodd",
    fill: "url(#master_svg8_1_299)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.42892074584961,15.423670492401122C15.42892074584961,15.423670492401122,28.04332074584961,15.423670492401122,28.04332074584961,15.423670492401122C28.04332074584961,15.423670492401122,28.04332074584961,8.146430492401123,28.04332074584961,8.146430492401123C28.04332074584961,8.146430492401123,15.42892074584961,15.423670492401122,15.42892074584961,15.423670492401122C15.42892074584961,15.423670492401122,15.42892074584961,15.423670492401122,15.42892074584961,15.423670492401122Z",
    fillRule: "evenodd",
    fill: "url(#master_svg9_1_269)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.80419921875,15.423828125C2.80419921875,15.423828125,2.80419921875,22.711568125,2.80419921875,22.711568125C2.80419921875,22.711568125,15.42909921875,15.423828125,15.42909921875,15.423828125C15.42909921875,15.423828125,2.80419921875,15.423828125,2.80419921875,15.423828125C2.80419921875,15.423828125,2.80419921875,15.423828125,2.80419921875,15.423828125Z",
    fillRule: "evenodd",
    fill: "url(#master_svga_1_309)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.80419921875,15.423714884033203C2.80419921875,15.423714884033203,15.42909921875,15.423714884033203,15.42909921875,15.423714884033203C15.42909921875,15.423714884033203,2.80419921875,8.135974884033203,2.80419921875,8.135974884033203C2.80419921875,8.135974884033203,2.80419921875,15.423714884033203,2.80419921875,15.423714884033203C2.80419921875,15.423714884033203,2.80419921875,15.423714884033203,2.80419921875,15.423714884033203Z",
    fillRule: "evenodd",
    fill: "url(#master_svgb_1_314)",
    fillOpacity: 1
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.00209047363281,27.144405236816407L41.763470473632815,27.144405236816407L41.763470473632815,12.458735236816405L45.25313047363281,12.458735236816405L45.25313047363281,10.130145236816407L41.763470473632815,10.130145236816407L41.763470473632815,8.919275236816407C41.763470473632815,6.714875236816406,42.58278047363281,5.783445236816407,45.07106047363281,5.783445236816407L45.07106047363281,3.4238052368164062C40.82278047363281,3.4238052368164062,39.00209047363281,5.131435236816406,39.00209047363281,8.919275236816407L39.00209047363281,10.130145236816407L36.84761047363281,10.130145236816407L36.84761047363281,12.458735236816405L39.00209047363281,12.458735236816405L39.00209047363281,27.144405236816407ZM63.33861047363281,18.606205236816407C63.33861047363281,13.234935236816407,59.66691047363281,9.850715236816406,54.93311047363281,9.850715236816406C50.229710473632814,9.850715236816406,46.52761047363281,13.234935236816407,46.52761047363281,18.606205236816407C46.52761047363281,24.008505236816408,50.10831047363281,27.423805236816406,54.811710473632814,27.423805236816406C59.54551047363282,27.423805236816406,63.33861047363281,24.008505236816408,63.33861047363281,18.606205236816407ZM49.34971047363281,18.606205236816407C49.34971047363281,14.321605236816406,51.98971047363281,12.303495236816406,54.90281047363281,12.303495236816406C57.755210473632815,12.303495236816406,60.51661047363281,14.321605236816406,60.51661047363281,18.606205236816407C60.51661047363281,22.921905236816407,57.69451047363282,24.940005236816408,54.811710473632814,24.940005236816408C51.929010473632815,24.940005236816408,49.34971047363281,22.921905236816407,49.34971047363281,18.606205236816407ZM66.67661047363282,22.487205236816408C66.67661047363282,25.902505236816406,68.34551047363281,27.144405236816407,71.28901047363281,27.144405236816407L73.77731047363281,27.144405236816407L73.77731047363281,24.753705236816405L71.74411047363282,24.753705236816405C70.04481047363282,24.753705236816405,69.43791047363281,24.163805236816405,69.43791047363281,22.487205236816408L69.43791047363281,12.458735236816405L73.77731047363281,12.458735236816405L73.77731047363281,10.130145236816407L69.43791047363281,10.130145236816407L69.43791047363281,5.845535236816406L66.67661047363282,5.845535236816406L66.67661047363282,10.130145236816407L64.52211047363281,10.130145236816407L64.52211047363281,12.458735236816405L66.67661047363282,12.458735236816405L66.67661047363282,22.487205236816408ZM91.98411047363281,18.606205236816407C91.98411047363281,13.234935236816407,88.31241047363281,9.850715236816406,83.5786104736328,9.850715236816406C78.87521047363282,9.850715236816406,75.17311047363282,13.234935236816407,75.17311047363282,18.606205236816407C75.17311047363282,24.008505236816408,78.75381047363281,27.423805236816406,83.45731047363282,27.423805236816406C88.19101047363282,27.423805236816406,91.98411047363281,24.008505236816408,91.98411047363281,18.606205236816407ZM77.99521047363281,18.606205236816407C77.99521047363281,14.321605236816406,80.63521047363281,12.303495236816406,83.54831047363281,12.303495236816406C86.40071047363281,12.303495236816406,89.16211047363282,14.321605236816406,89.16211047363282,18.606205236816407C89.16211047363282,22.921905236816407,86.34001047363282,24.940005236816408,83.45731047363282,24.940005236816408C80.57451047363281,24.940005236816408,77.99521047363281,22.921905236816407,77.99521047363281,18.606205236816407ZM97.4766104736328,17.892105236816406C97.4766104736328,13.949005236816406,99.47931047363281,12.738165236816407,102.11931047363281,12.738165236816407L102.84761047363281,12.738165236816407L102.84761047363281,9.819665236816405C100.20761047363281,9.819665236816405,98.41731047363281,10.999485236816406,97.4766104736328,12.893405236816406L97.4766104736328,10.130145236816407L94.71521047363282,10.130145236816407L94.71521047363282,27.144405236816407L97.4766104736328,27.144405236816407L97.4766104736328,17.892105236816406Z",
    fill: "#FFFFFF",
    fillOpacity: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFotorgoart);
export default __webpack_public_path__ + "static/media/fotor goart.d3b156cb.svg";
export { ForwardRef as ReactComponent };